import { useState } from 'react';
import { Tabs, Wrapper } from '@screentone/core';

import { Settings } from 'components/artifact-settings/Settings';
import { Layout } from 'data/generated/graphql';
import styles from './LayoutRightPanel.module.scss';
import { LayoutHistory } from '../layout-history/LayoutHistory';
import { LayoutSettings } from '../layout-settings/LayoutSettings';

interface LayoutRightPanelProps {
  layout: Layout;
  artifactId: string;
}

export enum LayoutTabs {
  Settings,
  History
}

export const LayoutRightPanel = ({ layout, artifactId }: LayoutRightPanelProps) => {
  const [activeTab, setActiveTab] = useState<LayoutTabs>(LayoutTabs.Settings);

  const handleTabChange = (value: number) => {
    setActiveTab(value as LayoutTabs);
  };

  return (
    <Wrapper className={styles.rightPanelWrapper}>
      <Tabs value={activeTab} onChange={handleTabChange} margin={{ bottom: 'md' }} role="tablist">
        <Tabs.Item role="tab" aria-selected={activeTab === LayoutTabs.Settings ? 'true' : 'false'}>
          Settings
        </Tabs.Item>
        <Tabs.Item role="tab" aria-selected={activeTab === LayoutTabs.History ? 'true' : 'false'}>
          Publish History
        </Tabs.Item>
      </Tabs>

      {activeTab === LayoutTabs.Settings && (
        <Settings title="Settings">
          <LayoutSettings layout={layout} />
        </Settings>
      )}

      {activeTab === LayoutTabs.History && (
        <Wrapper padding={{ top: 'sm' }}>
          <LayoutHistory artifactId={artifactId} />
        </Wrapper>
      )}
    </Wrapper>
  );
};
